export const ru = {
    manager: 'Менеджер',
    'support-phone': 'Телефоны поддержки'
};
